export enum TypeSourceIncomeEnum {
  PROFESSIONAL_ACTIVITIES = 'P',
  MAINTENANCE = 'M',
  RENTS = 'R',
  RETIREMENT = 'J',
  OTHER = 'O'
}

export const NAME_SOURCE_INCOME = {
  P: 'Actividades profesionales',
  M: 'Manutención',
  R: 'Rentas',
  J: 'Jubilación',
  O: 'Otra fuente de ingreso'
} as const

export const TYPE_SOURCE_INCOME = {
  PROFESSIONAL_ACTIVITIES: 'P',
  MAINTENANCE: 'M',
  RENTS: 'R',
  RETIREMENT: 'J',
  OTHER: 'O'
} as const

export type TypeSourceIncome = 'P' | 'M' | 'R' | 'J' | 'O'

export const CATALOG_SOURCE_INCOME = [
  { value: TYPE_SOURCE_INCOME.PROFESSIONAL_ACTIVITIES, label: NAME_SOURCE_INCOME.P },
  { value: TYPE_SOURCE_INCOME.MAINTENANCE, label: NAME_SOURCE_INCOME.M },
  { value: TYPE_SOURCE_INCOME.RENTS, label: NAME_SOURCE_INCOME.R },
  { value: TYPE_SOURCE_INCOME.RETIREMENT, label: NAME_SOURCE_INCOME.J },
  { value: TYPE_SOURCE_INCOME.OTHER, label: NAME_SOURCE_INCOME.O }
]
